<header ng-if="showHeader">
    <h2 ng-click="toggle()" class="handle">{{ "tags"|translate }}</h2>
    <span class="help-text" ng-if="detached ==='true' && tags.length > 0">{{"clickToRemove"|translate}}</span>
</header>
<section class="details">
    <span class="help-text" ng-if="tags.length == 0">{{placeholder}}</span>

    <!--<div class="horizontal" c-toggle="horizontalViewVisible">
            <div class="tag" ng-repeat="tag in tags">
                <div class="level0" ng-class="{detached:detached === 'true'}" ng-click="onTagClick(tag)">{{tag.Name}}</div>
            </div>
        </div>-->

    <div class="tree" c-toggle="treeViewVisible">
        <div ng-repeat="tag in tagsTree">
            <div c-tag-tree tag="tag" detached="detached"></div>
        </div>
    </div>
</section>